var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import flattenDeep from './flattenDeep';
export default (function (plugins) {
    return Object.keys(plugins).reduce(function (acc, groupKey) {
        var group = plugins[groupKey];
        var groupPlugins = Object.keys(group).reduce(function (innerAcc, key) {
            var pluginOrFactory = plugins[groupKey][key];
            var result = typeof pluginOrFactory === 'function'
                ? pluginOrFactory()
                : pluginOrFactory;
            return __spreadArrays(innerAcc, flattenDeep(result));
        }, []);
        return __spreadArrays(acc, groupPlugins);
    }, []);
});
//# sourceMappingURL=makeSlatePluginsFromDef.js.map